"use strict";

exports.__esModule = true;
exports.CalendarEventConfigDetails = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var WEEKDAY_NAMES = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
var LOCALE_WEEKDAY_NAMES = Array.from({
  length: 7
}, function (_, i) {
  return new Date(1970, 0, i + 5).toLocaleString(undefined, {
    weekday: "long"
  });
});
var CalendarEventConfigDetails = exports.CalendarEventConfigDetails = /*#__PURE__*/function (_Component) {
  function CalendarEventConfigDetails() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(CalendarEventConfigDetails, _Component);
  var _proto = CalendarEventConfigDetails.prototype;
  _proto.render = function render() {
    var config = this.props.config;
    var occursWeekly = config.occursWeekly.map(function (day) {
      return /*#__PURE__*/_react["default"].createElement("em", {
        key: day
      }, LOCALE_WEEKDAY_NAMES[WEEKDAY_NAMES.indexOf(day)], " ");
    });
    var extra;
    if (config.type === "Classification") {
      extra = /*#__PURE__*/_react["default"].createElement("p", {
        "data-testid": "CalendarEventConfigDetails.extra"
      }, "Classifies as ", /*#__PURE__*/_react["default"].createElement("em", null, config.payload.activity), " ", /*#__PURE__*/_react["default"].createElement("em", null, "(", config.payload.state, ")"));
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "CalendarEventConfigDetails"
    }, /*#__PURE__*/_react["default"].createElement("p", null, config.type, " occurs weekly on ", occursWeekly, " between ", config.from, " ", "and ", config.to, "."), extra);
  };
  return CalendarEventConfigDetails;
}(_react.Component);